module.exports = __webpack_public_path__ + "img/twitter.2eaf1bee.png";